import debt from "../../assets/images/debt.png";
import ss from "../../assets/images/social_security.png";
import goals from "../../assets/images/goal.png";
import disability from "../../assets/images/doctor.png";
import divorce from "../../assets/images/latest/Divorce.png";
import death from "../../assets/images/casket.png";
import disaster from "../../assets/images/latest/Disaster.png";
import assets from "../../assets/images/asset.png";
import liabilities from "../../assets/images/debt.png";
import insurance from "../../assets/images/insurance.png";
import income from "../../assets/images/contributions.png";
import budget from "../../assets/images/calculator.png";

export const modules = [
    {
      id: 1,
      name: "assets",
      image: assets,
      title: "Assets",
      link: "",
    },
    {
      id: 4,
      name: "budget",
      image: budget,
      title: "Budget",
      link: "",
    },
    {
      id: 7,
      name: "death",
      image: death,
      title: "Death & Estate",
      link: "",
    },
    {
      id: 9,
      name: "debtPayoff",
      image: debt,
      title: "Debt Payoff",
      link: "",
    },
    {
      id: 6,
      name: "disasterDisability",
      image: disability,
      title: "Disaster & Disability",
      link: "",
    },

    {
      id: 8,
      name: "divorce",
      image: divorce,
      title: "Divorce",
      link: "",
    },
    {
      id: 11,
      name: "goals",
      image: goals,
      title: "Goals",
      link: "",
    },
    {
      id: 3,
      name: "insurance",
      image: insurance,
      title: "Insurance",
      link: "",
    },
    {
      id: 2,
      name: "liabilitiesandCredit",
      image: liabilities,
      title: "Liabilities and Credit",
      link: "",
    },

    {
      id: 10,
      name: "socialSecurity",
      image: ss,
      title: "Social Security",
      link: "",
    },
    {
      id: 5,
      name: "sourcesofIncome",
      image: income,
      title: "Sources of Income",
      link: "",
    },
  ];